import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import { useSelector, useDispatch } from 'react-redux';

import { updateClient } from 'src/module/authentication/action';
import { getClient, getTemperatureUnit } from 'src/module/authentication/selector';
import SwitchField from 'src/component/UI/SettingsModal/SettingsModalFields/SwitchField';
import { Map } from 'immutable';
import { InputLabel } from '@mui/material';
import { useTranslation } from 'src/i18n';
import { convertBand, convertBandFromDisplayToCelsius } from 'src/utils/utils';

export default function ValidateCheckSection () {
  const { t } = useTranslation();
  const client: any = useSelector(getClient);
  const temperatureUnit: string = useSelector(getTemperatureUnit);
  const dispatch = useDispatch();

  const [validateEnabled, setValidateEnabled] = useState(
    client.getIn(['preferences', 'validateCheckWhenCreatingForcingOnLogs'], false)
  );
  // Stored value is a Celsius-delta; edit it in the operator's unit.
  const [safetyFactor, setSafetyFactor] = useState<number>(
    convertBand(client.getIn(['preferences', 'safetyFactor'], 40) || 40, temperatureUnit)
  );

  const save = (enabled: boolean, factor: number) => {
    dispatch(updateClient(client.get('name'), Map({
      validateCheckWhenCreatingForcingOnLogs: enabled,
      // Persist as a canonical Celsius-delta regardless of the display unit.
      safetyFactor: convertBandFromDisplayToCelsius(factor, temperatureUnit),
    })));
  };

  return (
    <div className='validate-check-section' style={{ padding: '0px 0px 8px 0px' }}>
      <InputLabel className='mfa-label'>{t('clientProperties.validateCheckSection')}</InputLabel>

      <div className='mfa-switch'>
        <SwitchField
          value={validateEnabled}
          field={Map({ label: t('clientProperties.validateForcingLogs'), id: null })}
          handleChange={() => {
            const newEnabled = !validateEnabled;
            setValidateEnabled(newEnabled);
            save(newEnabled, safetyFactor);
          }}
        />
      </div>

      {validateEnabled && (
        <TextField
          className='safety-factor-field'
          id="safetyFactor"
          name="safetyFactor"
          label={`${t('clientProperties.safetyFactor')}${t('forcedOn.setPointUnit', { unit: temperatureUnit })}`}
          type="number"
          value={safetyFactor}
          onChange={(e) => setSafetyFactor(Number(e.target.value))}
          onBlur={() => save(validateEnabled, safetyFactor)}
          variant='outlined'
          InputLabelProps={{ shrink: false }}
        />
      )}
    </div>
  );
}
